//Shopify_Storefront_URL
export const USAShopifyStorefrontUrl = "https://railbox-consulting.myshopify.com/api/graphql";
export const CanadaShopifyStorefrontUrl = "https://northern-container-sales.myshopify.com/api/graphql";

//Shopify_Storefront_Token
export const USAStorefrontAccessToken = "56cb73c2f6c2f28d28c6adca55809a3e";
export const CanadaStorefrontAccessToken = "7a6db3e0cecae3c5095fc5d5b23a9c92";

//ShopifyStore_domain
export const USAShopifyDomain = "buy.westerncontainersales.com";
export const CanadaShopifyDomain = "northerncontainer.ca";
